var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#239ECA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 9.94543C22.0677 11.2337 20.5738 12.0676 18.8904 12.0676C16.0643 12.0676 13.772 9.7153 13.772 6.81376C13.772 5.31198 14.3855 3.95729 15.3687 3L23.0001 9.94543Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36919 19.5899C7.05088 18.7275 6.13349 17.2578 6.01333 15.533C5.81114 12.6386 7.93245 10.1237 10.7516 9.91616C12.2109 9.80821 13.5708 10.3396 14.5714 11.278L8.36919 19.5899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15137 20.0948C10.078 18.8018 11.5673 17.9596 13.2507 17.9512C16.078 17.9358 18.3807 20.2763 18.3946 23.1778C18.4026 24.6796 17.7949 26.0378 16.8174 26.9999L9.15137 20.0948Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarChatbot);
export default __webpack_public_path__ + "static/media/AvatarChatbot.c2da27f3c598ce9c00b715735880c2f0.svg";
export { ForwardRef as ReactComponent };